import * as service from './service'
export default {
  namespace: 'accidentTransferTransferFail',
  state: {
    demoData: {}
  },
  effects: {
    * demo ({ payload }, { call, put }) {
      const res = yield call(service.demo, payload)
      yield put({
        type: 'save',
        payload: {
          demoData: res.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
